import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

// noinspection JSValidateTypes
const DimensionsLabel = () => <FormattedMessage {...messages.package} />;

export default DimensionsLabel;
